export default __webpack_public_path__ + "static/media/seo.6b69c681.svg";